import React from 'react';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';
import Looks5Icon from '@mui/icons-material/Looks5';

export const DRAWER_WIDTH = 550;
export const SM_BREAKPOINT = 600;
export const MINI_SIDE_PANEL_WIDTH = 61;
export const MINI_SIDE_PANEL_DENSE_WIDTH = 45;

export const MINISIDEPANEL_CONFIG = [
  {id: 'girona', route: '../girona', label: 'girona', content: <LooksOneIcon/>},
  {id: 'mediterraneo', route: '../mediterraneo', label: 'mediterraneo', content: <LooksTwoIcon/>},
  {id: 'pirineo', route: '../pirineo', label: 'pirineo', content: <Looks3Icon/>},
  {id: 'bigterrain', route: '../bigterrain', label: 'bigterrain', content: <Looks4Icon/>},
  {id: 'contour', route: '../contour', label: 'contour', content: <Looks5Icon/>}
];

export const INITIAL_VIEWPORT = {
  latitude: 41.59451,
  longitude: 1.84119,
  zoom: 15,
  bearing: -110,
  pitch: 60
};

export const MAPSTYLES = [
  {
    'label': 'Ortofoto',
    'thumbnail': 'https://visors.icgc.cat/contextmaps/imatges_estil/icgc_orto_hibrida.png',
    'id': 'https://geoserveis.icgc.cat/contextmaps/icgc_orto_hibrida.json',
    'firstTopLayer': 'place-other'
  },
  {
    'label': 'Estándar',
    'thumbnail': 'https://visors.icgc.cat/contextmaps/imatges_estil/icgc_mapa_estandard.png',
    'id': 'https://geoserveis.icgc.cat/contextmaps/icgc_mapa_estandard.json',
    'firstTopLayer': 'place-other'
  },
  {
    'label': 'Gris',
    'thumbnail': 'https://visors.icgc.cat/contextmaps/imatges_estil/icgc_mapa_base_gris_simplificat.png',
    'id': 'https://geoserveis.icgc.cat/contextmaps/icgc_mapa_base_gris_simplificat.json',
    'firstTopLayer': 'place_other'
  },
  {
    'label': 'Fosc',
    'thumbnail': 'https://visors.icgc.cat/contextmaps/imatges_estil/icgc_mapa_base_fosc.png',
    'id': 'https://geoserveis.icgc.cat/contextmaps/icgc_mapa_base_fosc.json',
    'firstTopLayer': 'place-other'
  }
];

export const INITIAL_MAPSTYLE_URL = MAPSTYLES[1].id;

export const COLOR_RAMPS = [{
  id: 'BrewerSpectral11',
  color: '#973572',
  label: 'BrewerSpectral11'
}, {
  id: 'BrewerRdYlBu11',
  color: '#973572',
  label: 'BrewerRdYlBu11'
}, {
  id: 'BrewerRdBu11',
  color: '#973572',
  label: 'BrewerRdBu11'
}, {
  id: 'BrewerPuOr11',
  color: '#973572',
  label: 'BrewerPuOr11'
}];
